<template>
  <ContentWrap>
    <el-alert
      type="info"
      :closable="false"
      show-icon
      :title="caseAlertTitle"
      class="mb-12px"
    />
    <el-form :inline="true" :model="query" class="mb-12px" @submit.prevent>
      <el-form-item label="案号">
        <el-input v-model="query.caseNo" clearable class="!w-180px" />
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="query.title" clearable class="!w-160px" />
      </el-form-item>
      <el-form-item label="状态">
        <el-input v-model="query.status" clearable placeholder="如 PROCESSING" class="!w-140px" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">搜索</el-button>
        <el-button @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="list" border>
      <el-table-column prop="id" label="编号" width="80" />
      <el-table-column prop="caseNo" label="案号" min-width="140" />
      <el-table-column prop="title" label="标题" min-width="160" show-overflow-tooltip />
      <el-table-column prop="caseType" label="案由" width="100" />
      <el-table-column prop="status" label="状态" width="110" />
      <el-table-column prop="lawyerName" label="承办律师" width="110" />
      <el-table-column prop="lawyerId" label="律师ID" width="90" />
      <el-table-column prop="createTime" label="创建时间" width="160" />
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref } from 'vue'
import { FirmPortalApi, type FirmCaseVO } from '@/api/firm/portal'
import { getFirmWorkbenchContext } from '@/api/firm/auth'

defineOptions({ name: 'FirmPortalCase' })

const loading = ref(false)
const list = ref<FirmCaseVO[]>([])
const total = ref(0)
const isSelfMode = ref(false)
const caseAlertTitle = computed(() =>
  isSelfMode.value
    ? '本所正式案件只读。完整办案请用侧栏「案件工作台」（需开启 firmErpEnabled）。'
    : '本所正式案件只读（撮合付后案）。完整办案请用侧栏「案件工作台」（需开启 firmErpEnabled）。'
)
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  caseNo: undefined as string | undefined,
  title: undefined as string | undefined,
  status: undefined as string | undefined
})

const getList = async () => {
  loading.value = true
  try {
    const data = await FirmPortalApi.casePage(query)
    list.value = data?.list || []
    total.value = data?.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  query.pageNo = 1
  getList()
}

const resetQuery = () => {
  query.caseNo = undefined
  query.title = undefined
  query.status = undefined
  handleQuery()
}

onMounted(async () => {
  try {
    const ctx = await getFirmWorkbenchContext()
    isSelfMode.value = String(ctx?.bizMode || '').toUpperCase() === 'SELF'
  } catch {
    isSelfMode.value = false
  }
  await getList()
})
</script>
